import * as ActionTypes from '../Auth';

export function beginSignIn() {
    return {type: ActionTypes.BEGIN_SIGNIN};
}

export function cancelSignIn() {
    return {type: ActionTypes.CANCEL_SIGNIN};
}

export function beginJoin() {
    return {type: ActionTypes.BEGIN_JOIN};
}

export function cancelJoin() {
    return {type: ActionTypes.CANCEL_JOIN};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Auth.js